import action from "../commons/hospitalActionStatus";

export const getComplaintsRequestAction = () => {
  return {
    type: action.GET_COMPLAINTS_REQUEST,
    status: "GET_COMPLAINTS_REQUEST",
    requestState: true,
  };
};

export const getComplaintsSuccessAction = (result) => {
  return {
    type: action.GET_COMPLAINTS_SUCCESS,
    status: "Get Complaints retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getComplaintsFailureAction = (error) => {
  return {
    type: action.GET_COMPLAINTS_FAILURE,
    status: "Get complaints failure",
    error,
    requestState: false,
  };
};

export const getRisksRequestAction = () => {
  return {
    type: action.GET_RISKS_REQUEST,
    status: "GET_RISKS_REQUEST",
    requestState: true,
  };
};

export const getRisksSuccessAction = (result) => {
  return {
    type: action.GET_RISKS_SUCCESS,
    status: "Risk list retrieved sucessfully",
    result,
    requestState: false,
  };
};

export const getRisksFailureAction = (error) => {
  return {
    type: action.GET_RISKS_FAILURE,
    status: "Get Risk Listfailure",
    error,
    requestState: false,
  };
};
